// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__6hSzZ","right":"styles_right__cOeKX"};